module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"Payment gateway":"درگاه پرداخت","Go to payment gateway":"رفتن به درگاه پرداخت","Payment is only possible through approved accounts, otherwise your payment will be unsuccessful":"پرداخت فقط از طریق حساب های تایید شده امکان پذیر است و در غیر این صورت پرداخت شما ناموفق خواهد بود.","Select bank account":"انتخاب حساب بانکی"}}')
  delete Component.options._Ctor
}
